export class GroupedApplicantData
{
	applicantFirstName : string;
	applicantMiddleName : string;
	applicantLastName : string;
	applicantSSN : string;
	applicantDOB : Date;
	applicantEmail : string;
	applicantStreet : string;
	applicantCity : string;
	applicantState : string;
    applicantZipCode : string;
    monthlyIncome: number;
    rent : number;
    creditGroupScore : number;
    evictionGroupScore : number;
    rentToIncomeGroupScore : number;
    groupCriminalPass : boolean;
    groupEvictionPass : boolean;
    groupDecision: string;
    groupId : string;
    apiVendor: number;
    screeningId : number;
    groupInPrequal : boolean;
    public get totalScore() : number {
        return this.creditGroupScore + this.evictionGroupScore + this.rentToIncomeGroupScore
    }
    
}


export class GroupPMScorePointLossReason
{
    id: number;
    groupScoreEntryId: number;
    pointLoss: number;
    reason: string;
}